export default __webpack_public_path__ + "static/media/trash.f5624732.svg";